export enum UserRole {
    Admin = 'admin',
    AgencyAdmin = 'agency-admin',
    Candidate = 'candidate',
}
